/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPagePlannerSpecialtyFragmentDoc, SettingsPagePlannerFragmentDoc } from '../SettingsPage.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SettingsPageCorporationFragment = { id: string, name: string, branches: Array<{ id: string, name: string }> };

export type SettingsPageCorporationViewQueryVariables = Exact<{
  id: string | number;
}>;


export type SettingsPageCorporationViewQuery = { corporation: { id: string, name: string, branches: Array<{ id: string, name: string }> } };

export type SettingsPageCorporationPlannerQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageCorporationPlannerQuery = { planner: { id: string, name: string, slug: string, avatar: any, avatarUrl: string, cover: any, coverUrl: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ id: string, name: string }> } | null, specialties: Array<{ id: string, name: string }> };

export const SettingsPageCorporationFragmentDoc = gql`
    fragment SettingsPageCorporation on Corporation {
  id
  name
  branches {
    id
    name
  }
}
    `;
export const SettingsPageCorporationViewDocument = gql`
    query SettingsPageCorporationView($id: ID!) {
  corporation(id: $id) {
    ...SettingsPageCorporation
  }
}
    ${SettingsPageCorporationFragmentDoc}`;

/**
 * __useSettingsPageCorporationViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageCorporationViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageCorporationViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageCorporationViewQuery({
 *   id: // value for 'id'
 * });
 */
export function useSettingsPageCorporationViewQuery(variables: SettingsPageCorporationViewQueryVariables | VueCompositionApi.Ref<SettingsPageCorporationViewQueryVariables> | ReactiveFunction<SettingsPageCorporationViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageCorporationViewQuery, SettingsPageCorporationViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageCorporationViewQuery, SettingsPageCorporationViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageCorporationViewQuery, SettingsPageCorporationViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageCorporationViewQuery, SettingsPageCorporationViewQueryVariables>(SettingsPageCorporationViewDocument, variables, options);
}
export function useSettingsPageCorporationViewLazyQuery(variables?: SettingsPageCorporationViewQueryVariables | VueCompositionApi.Ref<SettingsPageCorporationViewQueryVariables> | ReactiveFunction<SettingsPageCorporationViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageCorporationViewQuery, SettingsPageCorporationViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageCorporationViewQuery, SettingsPageCorporationViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageCorporationViewQuery, SettingsPageCorporationViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageCorporationViewQuery, SettingsPageCorporationViewQueryVariables>(SettingsPageCorporationViewDocument, variables, options);
}
export type SettingsPageCorporationViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageCorporationViewQuery, SettingsPageCorporationViewQueryVariables>;
export const SettingsPageCorporationPlannerDocument = gql`
    query SettingsPageCorporationPlanner {
  planner {
    ...SettingsPagePlanner
  }
  specialties {
    ...SettingsPagePlannerSpecialty
  }
}
    ${SettingsPagePlannerFragmentDoc}
${SettingsPagePlannerSpecialtyFragmentDoc}`;

/**
 * __useSettingsPageCorporationPlannerQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageCorporationPlannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageCorporationPlannerQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageCorporationPlannerQuery();
 */
export function useSettingsPageCorporationPlannerQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageCorporationPlannerQuery, SettingsPageCorporationPlannerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageCorporationPlannerQuery, SettingsPageCorporationPlannerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageCorporationPlannerQuery, SettingsPageCorporationPlannerQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageCorporationPlannerQuery, SettingsPageCorporationPlannerQueryVariables>(SettingsPageCorporationPlannerDocument, {}, options);
}
export function useSettingsPageCorporationPlannerLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageCorporationPlannerQuery, SettingsPageCorporationPlannerQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageCorporationPlannerQuery, SettingsPageCorporationPlannerQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageCorporationPlannerQuery, SettingsPageCorporationPlannerQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageCorporationPlannerQuery, SettingsPageCorporationPlannerQueryVariables>(SettingsPageCorporationPlannerDocument, {}, options);
}
export type SettingsPageCorporationPlannerQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageCorporationPlannerQuery, SettingsPageCorporationPlannerQueryVariables>;